// extracted by mini-css-extract-plugin
export default {"mapContainer":"styles_mapContainer__-hMmd","container":"styles_container__StO5K","predictions":"styles_predictions__NJHtW"};